import config from "config";

export const PRE_NEED_LEAD_SCHEDULE_CONFIG = {
  calendly: {
    after_id: "pre_need_onboarding_payment",
    event_url: `${config.formHost}/pre-need-lead-halo-schedule`,
    analytics: {
      facebook: {
        event: "Schedule",
        data: {
          content_name: "pre-need-lead",
          content_category: "pre-need",
        },
      },
    },
  },
  phone: { after_id: "pre_need_onboarding_payment", number: "+18444150199" },
};
